import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';

var SystemLogOutboundOrderPage = function (_super) {
  __extends(SystemLogOutboundOrderPage, _super);

  function SystemLogOutboundOrderPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  SystemLogOutboundOrderPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  };

  SystemLogOutboundOrderPage.prototype.created = function () {
    this.columns = [{
      title: this.t('订单号'),
      dataIndex: 'order_code',
      filterEmpty: true
    }, {
      title: this.t('操作人'),
      dataIndex: 'user_name',
      filterEmpty: true
    }, {
      title: this.t('日志'),
      scopedSlots: {
        customRender: 'log_content'
      }
    }, {
      title: this.t('日志时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    this.queryOutboundOrderLogList();
  };

  SystemLogOutboundOrderPage.prototype.queryOutboundOrderLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.assistant.queryOutboundOrderLogList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = this.$util.createTableRowKey(list);
            this.total = total;
            return [2];
        }
      });
    });
  };

  SystemLogOutboundOrderPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'order_code',
      code_value: '',
      start_time: '',
      end_time: ''
    };
  };

  SystemLogOutboundOrderPage.prototype.handlePageChange = function (val) {
    this.initPage();
    this.searchData.page_index = val;
    this.queryOutboundOrderLogList();
  };

  SystemLogOutboundOrderPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryOutboundOrderLogList();
  };

  SystemLogOutboundOrderPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  SystemLogOutboundOrderPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryOutboundOrderLogList();
  };

  SystemLogOutboundOrderPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryOutboundOrderLogList();
    });
  };

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], SystemLogOutboundOrderPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], SystemLogOutboundOrderPage.prototype, "queryOutboundOrderLogList", null);

  __decorate([userPrefPageSize('systemLogOutboundOrderList')], SystemLogOutboundOrderPage.prototype, "getInitSearchData", null);

  SystemLogOutboundOrderPage = __decorate([Component], SystemLogOutboundOrderPage);
  return SystemLogOutboundOrderPage;
}(Vue);

export default SystemLogOutboundOrderPage;